import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import StoreDetailPage from "../components/StoreDetailPage";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const StoreDetail = () => {
  const { state } = useLocation();
  const [rbts, setRbts] = useState<any[]>([]);
  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );

  const getAllRbts = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Content/ToneListOfCategory?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${process.env.REACT_APP_LANGID}&catId=${
        state?.catId
      }&pageNo=-1&countryCode=${countryCode}&subType=P&planId=1&pageSize=1`
    );
    setRbts(res?.data?.toneListOfCategory);
  };

  useEffect(() => {
    getAllRbts();
  }, []);

  return (
    <Layout>
      <SidebarLayout>
        <StoreDetailPage tones={rbts} />
      </SidebarLayout>
    </Layout>
  );
};

export default StoreDetail;
